import React from 'react';
import styles from './pre-order.module.css';

export default function PreOrder() {
  return (
    <section id="order-header" className={styles.preOrderHeader}>
      <div className={styles.container}>
        <h2 className="section-header center">Get Your Copy Now</h2>
        <div className={styles.retailerButtons}>

          {/* Top row: Amazon CTA + Audible */}
          <div className={styles.ctaTopRow}>
            <a
              href="https://amzn.to/3ZkOofb"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.ctaAmazonBtn}
              data-retailer="Amazon"
              data-retailer-btn
              data-format="paperback"
            >
              <img src="assets/retailers/amazon-a-yellow.png" alt="" className={styles.ctaAmazonLogo} />
              <span className={styles.ctaAmazonText}>Buy on Amazon</span>
            </a>
            <a
              href="https://amzn.to/4kmpQMv"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.audibleBtn}
              data-retailer="Amazon"
              data-retailer-btn
              data-format="audiobook"
            >
              <img src="assets/retailers/audible-logo.png" alt="" className={styles.audibleLogo} />
              <span>Listen on Audible</span>
            </a>
          </div>

          <div className={styles.otherRetailers}>
            <h4>Or purchase from these retailers</h4>
            <div className={styles.otherRetailerButtons}>
              <a
                href="https://bookshop.org/p/books/the-new-rules-of-women-s-health-your-guide-to-thriving-at-every-age-meghan-rabbitt/9317fe43c0e979e0"
                target="_blank"
                className={`${styles.retailerBtn} ${styles.bookshop}`}
                data-retailer="Bookshop"
                data-retailer-btn>
                <img src="assets/retailers/bookshop-transparent.png" alt="Bookshop" className={styles.retailerLogo} />
              </a>
              <a
                href="https://www.barnesandnoble.com/w/the-new-rules-of-womens-health-meghan-rabbitt/1147278506"
                target="_blank"
                className={`${styles.retailerBtn} ${styles.barnes}`}
                data-retailer="Barnes & Noble"
                data-retailer-btn
              >
                <img src="assets/retailers/b&n-logo.svg" alt="Barnes & Noble" className={styles.retailerLogo} />
              </a>
              <a
                href="https://www.target.com/p/the-new-rules-of-women-s-health-by-meghan-rabbitt-paperback/-/A-1003285624"
                target="_blank"
                className={`${styles.retailerBtn} ${styles.target}`}
                data-retailer="Target"
                data-retailer-btn
              >
                <img src="assets/retailers/target-transparent.png" alt="Target" className={styles.retailerLogo} />
              </a>
              <a
                href="https://www.walmart.com/ip/The-New-Rules-of-Women-apos-s-Health-Your-Guide-to-Thriving-at-Every-Age-Paperback-9780143137962/16071267333"
                target="_blank"
                className={`${styles.retailerBtn} ${styles.walmart}`}
                data-retailer="Walmart"
                data-retailer-btn
              >
                <img src="assets/retailers/walmart-transparent.png" alt="Walmart" className={styles.retailerLogo} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}